import { useMutation } from '@tanstack/react-query'

import { UpdateResidentVehicle } from '@/models'
import { resetQueries } from '@/utils'

import { authAPI } from '../new-api'
import { GET_PARKING_SPOTS_BASE_QUERY_KEY } from './get-parking-spots'
import { GET_RESIDENT_VEHICLES_BASE_QUERY_KEY } from './get-resident-vehicles'

export interface UpdateResidentVehiclesRequest {
  clientId: number
  vehicles: UpdateResidentVehicle[]
  confirmAssociation?: boolean
}

export interface UpdateResidentVehiclesVehicle {
  id: number
  licensePlate: string
  make: string
  model: string
  color: string
  year: number
  permitTag: string
  status: string
  source: string
}

export type UpdateResidentVehiclesResponse = UpdateResidentVehiclesVehicle[]

export const updateResidentVehicles = async (data: UpdateResidentVehiclesRequest) => {
  const response = await authAPI.put<UpdateResidentVehiclesResponse>(
    '/parking/client-vehicles',
    {
      confirmAssociation: data.confirmAssociation,
      vehicles: data.vehicles,
    },
    { params: { clientId: data.clientId } },
  )
  return response.data
}

export const useUpdateResidentVehicles = () => {
  return useMutation({
    mutationFn: updateResidentVehicles,
    onSuccess: async () => {
      await resetQueries([GET_RESIDENT_VEHICLES_BASE_QUERY_KEY], [GET_PARKING_SPOTS_BASE_QUERY_KEY])
    },
  })
}
